import { createContext, useContext } from "react";

import type { useChangePhoneNumber } from "./use-change-phone-number";

type ChangePhoneNumberContextValue = ReturnType<typeof useChangePhoneNumber>;

export const ChangePhoneNumberContext = createContext<ChangePhoneNumberContextValue | null>(null);

export function useChangePhoneNumberContext(): ChangePhoneNumberContextValue {
  const context = useContext(ChangePhoneNumberContext);
  if (!context)
    throw new Error("Change phone number parts must be rendered inside <ChangePhoneNumber>");
  return context;
}
